module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLightItalic.e4d0c1f4.ttf";